
import { Link } from "../../../components/link/link";
import Title from "../../../components/texts/title";
import { _sizeHeading, url_telegram } from "../../../core/core";



export const SupportTitle = () => {
  return (
    <div className="support-header-group">
      <Title type={_sizeHeading.h2_2}>Поддержка</Title>
      <Link
        blank
        link={url_telegram}
        icon_left={
          <svg
            className="group-1321313971"
            width="19"
            height="16"
            viewBox="0 0 19 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.2135 1.07292L15.4821 15.019C15.4821 15.019 15.3647 15.6563 14.5743 15.6563C14.1543 15.6563 13.9377 15.4565 13.9377 15.4565L8.02125 10.547L5.12646 9.08792L1.41135 8.0999C1.41135 8.0999 0.75 7.90886 0.75 7.36198C0.75 6.90625 1.43031 6.68896 1.43031 6.68896L16.9732 0.514377C16.9732 0.514377 17.4479 0.343023 17.7943 0.343752C18.0072 0.343752 18.25 0.434898 18.25 0.708336C18.25 0.890627 18.2135 1.07292 18.2135 1.07292Z"
              fill="white"
            />
            <path
              d="M10.2292 12.3787L7.73106 14.8389C7.73106 14.8389 7.62242 14.9227 7.47731 14.9264C7.427 14.9278 7.37304 14.9198 7.31763 14.895L8.02054 10.5455L10.2292 12.3787Z"
              fill="#B0BEC5"
            />
            <path
              d="M15.2582 3.40334C15.135 3.24292 14.9075 3.21375 14.7471 3.33552L5.125 9.09375C5.125 9.09375 6.66063 13.39 6.89469 14.1338C7.12948 14.8782 7.3176 14.8957 7.3176 14.8957L8.02052 10.5463L15.1897 3.91375C15.3501 3.79198 15.38 3.56375 15.2582 3.40334Z"
              fill="#CFD8DC"
            />
          </svg>
        }
      >
        Чат
      </Link>
    </div>
  );
};
